import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/material'
import ActiveFilters from '../../../components/PageHelpers/ActiveFilters'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'
import FormModalContainer from '../../../components/Modals/FormModalContainer'
import UseTranslation from '../../../hooks/UseTranslation'
import MenuListMultiSelect from '../../../components/Forms/MenuListMultiSelect'
import { filterImportUsersRolesDetailsList } from '../../../redux/features/importUsersRolesDetails/importUsersRolesDetailsThunk'
import { selectImportUsersRolesDetails } from '../../../redux/features/importUsersRolesDetails/importUsersRolesDetailsSlice'

const Mobile = ({
  openModal, setOpenModal,
}) => {
  const importUsersRolesDetails = useSelector(selectImportUsersRolesDetails)
  const dispatch = useDispatch()

  const { t } = UseTranslation()
  const handleClose = () => {
    setOpenModal(false)
  }
  const clearAllFilters = () => {
    dispatch(filterImportUsersRolesDetailsList({ queries: 'clear' }))
  }

  return (
    <FormModalContainer
      modalTitle={`${t?.['Filter By']}`}
      modalState={openModal}
      handleClose={handleClose}
      cancelText={t?.close}
    >
      <Box sx={styles.filterBox}>
        <ActiveFilters
            store={importUsersRolesDetails}
            actionToDispatch={filterImportUsersRolesDetailsList}
            customStyle={styles.activeFilter}
          />
         <MenuListMultiSelect
            store={importUsersRolesDetails}
            actionToDispatch={filterImportUsersRolesDetailsList}
        />
        <OfoqThemeBtn
        name={`${t?.['Clear Filters']}`}
         onClick={clearAllFilters}
        customStyle={styles.clearFilters}
      />
      </Box>
    </FormModalContainer>
  )
}

const styles = {
  firstFilter: {
    marginInline: { xs: '0px', md: '10px' },
    marginBottom: '0px',
  },
  activeFilter: {
    flexWrap: 'wrap',
  },
  clearFilters: {
    width: { xs: '100%', sm: '0px' },
    maxWidth: { xs: '100%', md: '150px' },
    minWidth: { xs: '80px', sm: '0px' },
    marginTop: { xs: '30px', sm: 'unset' },
  },
  filterBox: {
    display: 'flex',
    gap: { xs: '5px', md: '23px' },
    width: '100%',
    flexDirection: { xs: 'column', sm: 'row' },
    my: '10px',
  },
}
export default Mobile
